import { TBctxItemWithoutSizeAndBctxKey, TBctxKeysToDisplayMap, TBCTXKeysWithoutSize } from '@monorepo/types';
import { ModifiersZTableModel } from '@monorepo/ui';
function getDisplayName(item: TBctxItemWithoutSizeAndBctxKey, key: TBCTXKeysWithoutSize) {
  const index = item.list.findIndex(({ k }) => k === key);
  return index > -1 && item.list[index].v ? item.list[index].v : '--';
}
export const BCTX_SELECTION_LISTING_MODEL = {
  createModel: (
    items: TBctxItemWithoutSizeAndBctxKey[],
    orderKeys: TBCTXKeysWithoutSize[],
    bctxKeysToDisplayMap: TBctxKeysToDisplayMap,
  ) => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        headerConfig: orderKeys.map((keyWithoutSize) => {
          return {
            type: 'TEXT_CELL',
            text: bctxKeysToDisplayMap[keyWithoutSize],
          };
        }),
        select: {
          position: 'END',
          isMulti: false,
          size: 'LARGE',
        },
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          isSelected: false,
          cells: orderKeys.map((keyWithoutSize) => {
            return {
              type: 'TEXT_CELL',
              text: getDisplayName(item, keyWithoutSize),
            };
          }),
        };
      },
    );
  },
};
